module.exports = __webpack_public_path__ + "static/media/HCMM797.358fad29.jpg";